"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV = {
    local: 'local',
    development: 'development',
    test: 'test',
    staging: 'staging',
    prod: 'prod',
};
exports.LOG_TYPE = {
    error: 'error',
    warning: 'warning',
    info: 'info',
};
